// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"9e126c5c","784":"88ecf3f9","787":"b7bebe0e"}[chunkId] + ".chunk.js";
};